import kapitolLogoFooter from '@/images/clients/kapitol-logo.svg'
import { Market } from 'BrokerTsLib/src/enums'
import type { IPartnerSettings } from '.'

export const Kapitol: IPartnerSettings = {
  partner: 'Kapitol',
  deployment: 'Kapitol',
  hosts: [
    'srovnavacaut.kapitol.cz'
    //, 'localhost:44470'
  ],
  logo: kapitolLogoFooter,
  market: Market.CZ
}
